import { render } from "./ViewAttributePenyusunan.vue?vue&type=template&id=c7dba87e"
import script from "./ViewAttributePenyusunan.vue?vue&type=script&lang=js"
export * from "./ViewAttributePenyusunan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__